import React from 'react';
import AMV2AssetSelector from './AMV2AssetSelector';
import cbModal from '../Modal/Modal';
import { ModalProps } from '../Modal/Modal';
import { AMV2AssetPickerArgs, AMV2UploadTargetArgs } from './utils/types';

const openAMV2UploadTargetModal = (args: AMV2UploadTargetArgs, modalProps?: ModalProps) => {
  const enhancedModalProps: ModalProps = {
    ...modalProps,
    size: 'large',
    customClass: modalProps?.customClass
      ? modalProps.customClass
      : 'AssetFieldModal-wide-popup V2-select-wide-popup UploadTargetModal'
  };

  const uploadArgs: AMV2AssetPickerArgs = {
    ...args,
    mode: 'uploadTarget',
    hideStackAssetsSwitch: true,
    isVariantPlanEnabled: () => false,
  };

  cbModal({
    component: props => (
      <AMV2AssetSelector
        {...props}
        {...uploadArgs}
      />
    ),
    modalProps: enhancedModalProps
  });
};

export default openAMV2UploadTargetModal;
